import { isNum } from './isNum';

const px = number => (isNum(number) && number !== 0 ? number + 'px' : number);

export default px;
